import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader } from "@/components/site/Blocks";
import { ContactForm } from "@/components/site/ContactForm";
import { OfficesSection } from "@/components/site/OfficesSection";

import { SITE } from "@/data/site";
import { buildHead } from "@/lib/seo-head";
import { PageEssentials, PageOutro } from "@/components/site/PageEssentials";
import heroContact from "@/assets/hero/hero-contact-female.jpg.asset.json";

const HERO = {
  src: heroContact.url,
  alt: "Friendly female loan officer smiling on a phone call at a bright desk with a laptop, a rental duplex visible through the office window",
};

const URL = "/contact";
const KEYWORDS = [
  "contact DSCR lender",
  "DSCR loan officer phone number",
  "investment property loan officer",
  "talk to a mortgage broker",
  "business purpose loan contact",
  "DSCR loan scenario review",
  "Florida investor lender contact",
  "Colorado investor lender contact",
  "get pre-approved rental loan",
  "speak with a loan officer",
].join(", ");

export const Route = createFileRoute("/contact")({
  head: () =>
    buildHead({
      title: "Contact — DSCR Loan Officer | Simply Approved Mortgages",
      description:
        "Contact the Simply Approved DSCR desk. Initial scenario review on complete applications — usually same business day. Formal pricing and terms follow underwriting.",
      url: URL,
      keywords: KEYWORDS,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "Contact", url: URL },
      ],
      service: { name: "DSCR & Business-Purpose Loan Origination" },
      image: HERO.src,
      imageAlt: HERO.alt,
    }),
  component: Contact,
});

function Contact() {
  return (
    <SiteShell>
      <PageHero eyebrow="Contact" title="Talk to a loan officer." subtitle="Send a message or call the DSCR desk directly." image={HERO} />
      <PageEssentials />
      <Section>
        <div className="mx-auto max-w-3xl">
          <SectionHeader title="Contact us" intro={`Send your question or loan scenario below, or call ${SITE.phone}. A loan officer will follow up.`} />
          <div className="mt-6">
          <ContactForm />
          </div>
        </div>
      </Section>
      <OfficesSection />
    <PageOutro hideLeadForm />
      </SiteShell>
  );
}

